import React, { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import { CopyToClipboard } from "react-copy-to-clipboard"
import { Modal } from "antd"
// redux
import { connect } from "react-redux"
import { mapDispatchProps, mapStateToProps } from "../../store/store"
//
import API from "../../api"
import PRODUCT from "../../constants/product"
import Button from "../../components/button"
import { useLanguage } from "@languages/index"

function useForceUpdate() {
  const [value, setValue] = useState(0)
  return () => setValue((value) => value + 1)
}

const AdditionalProductsRecommendation = (props: any) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.products }
  const navigate = useNavigate()
  const forceUpdate = useForceUpdate()

  const [fetchedProducts, setFetchedProducts] = useState<any>([])
  // Alert Modal
  const [shouldShowAlertModal, setShouldShowAlertModal] = useState<Boolean>(false)
  const alertContent = useRef({ title: "", text: "" })

  /****************/
  /***** DATA *****/
  /****************/
  const fetchProducts = () => {
    const searchOptions = [
      { name: languageTexts.recommand_search_option_1, value: 0 },
      { name: languageTexts.recommand_search_option_2, value: 1 },
      { name: languageTexts.recommand_search_option_3, value: 2 },
      { name: languageTexts.recommand_search_option_4, value: 3 },
      { name: languageTexts.recommand_search_option_5, value: 4 },
      { name: languageTexts.recommand_search_option_6, value: 5 },
      { name: languageTexts.recommand_search_option_7, value: 6 },
      { name: languageTexts.recommand_search_option_8, value: 7 },
      { name: languageTexts.recommand_search_option_9, value: 8 },
    ]

    API.Product.index({
      ...{
        brandToken: props.auth.token,
        statusFl: searchOptions[4].value,
        type: "PRODUCT",
        productType: PRODUCT.TYPE_CD.RENTAL,
        size: 20,
        orderBy: "cart_cnt_in_two_weeks_desc",
      },
    })
      .then((response) => {
        setFetchedProducts(response.data.products)
      })
      .catch((error) => {
        props.showModal({ text: error.message })
      })
      .finally(() => {
        forceUpdate()
      })
  }

  /***************/
  /*** EFFECTS ***/
  /***************/
  useEffect(() => {
    fetchProducts()
  }, [])

  /***************/
  /*** RENDERS ***/
  /***************/
  const AlertModal = (props) => {
    return (
      <Modal
        className="squared-antd-modal"
        centered={true}
        open={props.shouldShowAlertModal}
        onOk={props.handleCancel}
        onCancel={props.handleCancel}
        footer={null}
        closable={false}
        zIndex={1010}
        width={400}
      >
        <div className="flex flex-col justify-center align-center p-8 bg-white">
          <div className="content flex flex-col">
            <span className="font-bold text-[22px] text-black">{alertContent.current["title"]}</span>
            <div className="flex flex-col items-start py-4">
              <span className="prose prose-md whitespace-pre-wrap leading-5 text-black">
                {alertContent.current["text"]}
              </span>
            </div>
          </div>
          <div className="buttons flex flex-col rows-2 mt-3 gap-1.5">
            <Button
              className={"min-w-[10rem] py-3 flex justify-center text-center text-base"}
              textColor={"WHITE"}
              buttonColor={"BLACK"}
              text={languageTexts.confirm}
              onClick={() => {
                props.handleCancel()
              }}
            />
          </div>
        </div>
      </Modal>
    )
  }

  const renderPageTitle = () => {
    return (
      <div className="container flex flex-col justify-center text-[22px] text-center">
        <div className="mt-[50px] px-5">
          <span className="font-bold">{languageTexts.recommand_text_1}</span>
        </div>
      </div>
    )
  }

  const renderAddressInfomation = (address) => {
    return (
      <div className="mx-[30px] mt-[50px] text-[15px]">
        <div className="text-left font-bold">{languageTexts.recommand_text_2}</div>
        <div className="flex flex-row mt-[15px] items-center">
          <div className="flex-grow" style={{ width: "80%" }}>
            {address}
          </div>
          <CopyToClipboard
            onCopy={(copied, result) => {
              let title = languageTexts.recommand_text_3
              let text = languageTexts.recommand_text_4
              if (!result) {
                title = languageTexts.recommand_text_5
                text = languageTexts.recommand_text_6
              }
              alertContent.current["title"] = title
              alertContent.current["text"] = text
              setShouldShowAlertModal(true)
            }}
            text={address}
          >
            <div
              className="ml-2 cursor-pointer underline font-bold text-[#999999] whitespace-nowrap text-center"
              style={{ width: "20%" }}
            >
              {languageTexts.recommand_text_7}
            </div>
          </CopyToClipboard>
        </div>
      </div>
    )
  }

  const renderProducts = () => {
    return (
      <div className="flex flex-col text-[15px] mx-[30px] mt-[50px] gap-[20px]">
        <div className="text-left font-bold">{languageTexts.recommand_text_8}</div>
        {fetchedProducts.map((p, i) => {
          return (
            <div key={`favoritePMs-${p["id"]}-${i}`} className="flex flex-row gap-5">
              <div className="basis-5 flex items-center">
                <div className="font-bold">{i + 1}</div>
              </div>
              <div className="basis-[100px] flex flex-row justify-items-center">
                <div className="w-[100px] h-[100px] overflow-hidden aspect-square">
                  <img className="w-full h-full object-cover" src={p["thumbnailSmUrl"]} />
                </div>
              </div>
              <div className="basis-full flex flex-col justify-center gap-1">
                <div className="font-bold">{`${p["name"]} - ${p["colorName"]}`}</div>
                {/* <div className="flex flex-row mt-2 whitespace-pre">
                  <div className="text-[#999999]">{`옷장에 담긴 수 `}</div>
                  <div className="text-[#000000] font-bold">
                    {p["favoriteCnt"]}
                  </div>
                  <div className="text-[#999999]">{languageTexts.recommand_text_9}</div>
                  <div className="text-[#000000] font-bold">{p["views"]}</div>
                </div> */}
                <div className="flex flex-row whitespace-pre">
                  <div className="text-[#999999]">{languageTexts.recommand_text_10}</div>
                  <div className="text-[#000000] font-bold">{p["qty"]}</div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  /**************/
  /**** MAIN ****/
  /**************/
  return (
    <div className="flex flex-col w-[480px] max-h-[80dvh] overflow-scroll">
      <div className="modal-window bg-white mb-10">
        <div className="modal-header">{renderPageTitle()}</div>
        <div className="modal-header">{renderAddressInfomation(languageTexts.recommand_text_11)}</div>
        <div className="modal-body">{renderProducts()}</div>
        <div className="mt-5" />
      </div>
      <AlertModal shouldShowAlertModal={shouldShowAlertModal} handleCancel={(e) => setShouldShowAlertModal(false)} />
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(AdditionalProductsRecommendation)
